let workerURL = require('./helpers/get-worker-url');
let bundleURL = require('./helpers/bundle-url');
let url = bundleURL.getBundleURL('4SxJc') + "css.worker.98a7418c.js";module.exports = workerURL(url, bundleURL.getOrigin(url), false);